import { coreApp } from "../../App/CoreApp"
import { CoreApiRequestMethod, CoreBaseApi, CoreBaseApiBasicResult, CoreBaseApiResult } from "../CoreBaseApi";
import { CoreBaseApiEndpoint } from "../CoreBaseApiEndpoint";

export class CoreBaseApiSimulationEndpoint extends CoreBaseApiEndpoint {
    public setStatus(status: CoreBaseApiSimulationStatus): Promise<CoreBaseApiBasicResult> {
        return this.api.sendBasicRequest(`api/Simulation/SetStatus`, CoreApiRequestMethod.PUT, {
            simKey: coreApp.simKey,
            status: status,
        }, null, () => {
            localStorage.setItem('sim-status', status.toString());
        });
    }

    constructor(api: CoreBaseApi) {
        super(api)
    }
}

export enum CoreBaseApiSimulationStatus {
    InProgress = 1,
    Passed = 2,
    Completed = 3,
    Failed = 4
}